<template>
  <div>
    <server-error :error="error" />
    <div style="display:flex">
      <h2>Delete {{ entityName }}</h2>
      <div :data-cy="entityName + '-delete'">
        <div v-if="entityName === 'asset'">
          assetName
          <input data-cy="input-asset-name" v-model="assetName" />
          underlyingAssetTypeName
          <input
            class="b-input"
            data-cy="input-underlying-asset-type-name"
            v-model="underlyingAssetTypeName"
          />
        </div>
        <div v-else>
          ITN
          <input data-cy="input-itn" class="b-input" v-model="itn" />
          <div v-if="entityName === 'legal-person'">
            RRC
            <input class="b-input" data-cy="input-rrc" v-model="rrc" />
          </div>
        </div>
        <button :data-cy="entityName + '-delete-button'" @click="deleteEntity()">Delete</button>
        <div data-cy="result" v-if="isDone" style="color:green">done</div>
      </div>
    </div>
  </div>
</template>

<script>
import CounterpartiesAPI from "../../api/CounterpartiesAPI";
import AssetAPI from "../../api/AssetAPI";

export default {
  name: "DeleteEnityWdiget",
  props: {
    entityName: {
      required: true,
      type: String
    }
  },
  data() {
    return {
      isDone: false,
      itn: null,
      rrc: null,
      assetName: null,
      underlyingAssetTypeName: null,
      error: null
    };
  },
  methods: {
    async deleteEntity() {
      try {
        this.error = null;
        const counterpartyAPI = new CounterpartiesAPI();
        const assetAPI = new AssetAPI();
        if (this.entityName == "legal-person") {
          await counterpartyAPI.deleteLegalPerson(this.itn, this.rrc);
        } else if (this.entityName == "natural-person") {
          await counterpartyAPI.deleteNaturalPerson(this.itn);
        } else if (this.entityName == "sp-person") {
          await counterpartyAPI.deleteSoleProprietorship(this.itn);
        } else if (this.entityName == "asset") {
          const encodedAssetName = encodeURIComponent(this.assetName);
          const encodedunderlyingAssetTypeName = encodeURIComponent(
            this.underlyingAssetTypeName
          );
          await assetAPI.deleteAsset(
            encodedAssetName,
            encodedunderlyingAssetTypeName
          );
        }

        this.isDone = true;
      } catch (e) {
        this.error = e;
      }
    }
  }
};
</script>
<style>
.config {
  margin: 20px;
}
</style>

